import eventBus from '@/utils/eventBus';
import BusinessService from '@/api/BusinessService';
import store from '@/store';

const businessService = new BusinessService();

const updateBusinessStore = (businessInfo: any) => {
  store.dispatch('business/SET_BUSINESS_INFO', businessInfo);
};

const emitBusinessUpdateEvent = (businessInfo: any) => {
  eventBus.$emit('setBusinessInfo', businessInfo);
};

const injectManagerData = (businessInfo: any) => {
  return {
    ...businessInfo,
    manager: businessInfo.loggedInManager
  };
};

const refreshBusinessInformation = async (
  forceRefesh: boolean = false
): Promise<void> => {
  const businessStored = store.getters['business/getBusinessInfo'].business;

  if (businessStored && !forceRefesh) {
    emitBusinessUpdateEvent(businessStored);
    updateBusinessStore(businessStored);

    return;
  }

  try {
    const response = await businessService.getBusinessInfo();

    const data = injectManagerData(response.data);

    emitBusinessUpdateEvent(data);
    updateBusinessStore(data);
  } catch (error) {
    console.error(error);
  }
};

export { refreshBusinessInformation };
export default refreshBusinessInformation;
